import { ReportApiFp, ReportControllerCardStats200Response, ReportControllerRank200Response } from "@api/api";
import { apiConfig } from "@factory/query/config";


export type GetResponseReportCardStat = ReportControllerCardStats200Response;
export type GetResponseReportRank = ReportControllerRank200Response;

export const apiReportFp = ReportApiFp(apiConfig);
export const cardStatsReportController = apiReportFp.reportControllerCardStats;
export const ageRangeReportController = apiReportFp.reportControllerAgeRange;
export const rankReportController = apiReportFp.reportControllerRank;
export const campaignReportController = apiReportFp.reportControllerCampaign;
export const earnPointsReportController = apiReportFp.reportControllerEarnPoints;
export const earnStampReportController = apiReportFp.reportControllerEarnStamp;
export const redeemPointsReportController = apiReportFp.reportControllerRedeemPoints;
export const redeemStampReportController = apiReportFp.reportControllerRedeemStamp;